// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {


	/* Trio Slider Functionality */
	let trioItem = document.getElementsByClassName('trio-rotator__each');

	if (trioItem) {
		for (let c = 0; c < trioItem.length; c++) {
			trioItem[c].addEventListener('mouseenter', function () {

				let inaciveItems = document.getElementsByClassName('trio-rotator__each');
				for (let x = 0; x < inaciveItems.length; x++) {
					inaciveItems[x].classList.add('noHover');
				};

				this.classList.remove('noHover');
				this.classList.add('hover');
			});
			trioItem[c].addEventListener('mouseleave', function () {
				let inaciveItems = document.getElementsByClassName('trio-rotator__each');
				for (let x = 0; x < inaciveItems.length; x++) {
					inaciveItems[x].classList.remove('noHover', 'hover');
				};
			});
		}
	}

	/* Tabs Quad Functionality */
	function setupTabs(containerClass, tabClass) {
		if (document.getElementsByClassName(containerClass)[0]) {
			let allTabs = document.querySelectorAll(`.${tabClass} li`);
			for (let c = 0; c < allTabs.length; c++) {
				allTabs[c].addEventListener('click', function () {
					let currentTabDataRef = this.getAttribute("data-ref");
					document.querySelectorAll(`.${containerClass} [data-ref]`).forEach(item => { item.classList.remove('active'); })
					document.querySelectorAll(`[data-ref="${currentTabDataRef}"]`).forEach(item => { item.classList.add('active'); })
				});
			}
		}
	}	
	
	setupTabs("tabs-block", "tabs-block__tabs");
	setupTabs("tabs-block-text", "tabs-block-text__tabs");
	
	/* END */


	//full navigation
	const fullnav = document.querySelector('.header__nav-holder');
	const primaryNav = {
		navOpen: document.querySelector('.nav-btn-js'),
		navClose: document.querySelector('.close-btn-js')
	};

	if (fullnav) {
		primaryNav.navOpen.addEventListener('click', function () {
			fullnav.classList.add('expanded');
		});
		primaryNav.navClose.addEventListener('click', function () {
			fullnav.classList.remove('expanded');
		});
	}

	//booking widget hide and show
	//if (!document.getElementsByTagName("body")[0].classList.contains("san-miguel")) {
		const full_booking = document.querySelector('.booking-widget');
		const booking_widget = {
			booking_open: document.querySelector('.booking-trigger-js'),
			booking_close: document.querySelector('.close-booking-js')
		};

		if (full_booking) {
			// console.log( full_booking );

			if( booking_widget.booking_open != null ) {
				booking_widget.booking_open.addEventListener('click', function () {
					full_booking.classList.remove('hidden');
					full_booking.classList.add('expanded');
					booking_widget.booking_open.style.display = "none";
					document.getElementById('header').classList.add('open-widget');
				});
			}
			if(booking_widget.booking_close != null ) {
				booking_widget.booking_close.addEventListener('click', function () {
					full_booking.classList.add('hidden');
					full_booking.classList.remove('expanded');
					booking_widget.booking_open.style.display = "inline-block";
					document.getElementById('header').classList.remove('open-widget');
				});
			}
		}
		//end booking widget hide and show

		//homepage booking widget scroll
		let scrollpos = window.scrollY
		const hero_home = document.querySelector('.top-content-home');
		const full_header = !document.getElementsByTagName("body")[0].classList.contains("san-miguel") ? document.querySelector('.header'): document.querySelector('.header-allende');

		const add_class_on_scroll = () => {
			/*full_booking.classList.add("booking-lockit"),*/
				full_header.classList.add("header-showbutton")
		}
		const remove_class_on_scroll = () => {
			/*full_booking.classList.remove("booking-lockit"),*/
				full_booking.classList.remove("expanded"),
				full_header.classList.remove("header-showbutton")
		}

		window.addEventListener('scroll', function () {
			scrollpos = window.scrollY;

			if (hero_home) {
				let header_height = hero_home.offsetHeight - 165;
				
				if (scrollpos >= header_height) { add_class_on_scroll() }
				else { remove_class_on_scroll() }
			}

			if (scrollpos >= 80) {
				if(full_header) {
					full_header.classList.remove("up"),
					full_header.classList.add("down");
				}
				if( full_booking) {
					full_booking.classList.remove("up"),
					full_booking.classList.add("down")
				}
			}
			else {
				if(full_header) {
					full_header.classList.remove("down"),
					full_header.classList.add("up");
				}
				if(full_booking) {
					full_booking.classList.remove("down"),
					full_booking.classList.add("up")
				}
			}

			//console.log(scrollpos)
		});
		//end booking widget scroll
	//}
	//end validation

	//map
	let map_pins = document.querySelectorAll(".each-pin");
	Array.from(map_pins).forEach(item => {
		item.addEventListener("click", () => {
			let selected = document.getElementsByClassName("pin-active");
			selected[0].className = selected[0].className.replace(" pin-active", "");
			item.className += " pin-active";
		});
	});


	//end map
	if(document.querySelectorAll(".dropdown").length > 0) { 
		document.querySelectorAll(".dropdown").forEach(dropdown => {
			if(dropdown.getElementsByClassName("selected").length > 0) { 
				let selected = dropdown.getElementsByClassName("selected")[0],
					selectedText = selected.textContent;
				
				dropdown.style.setProperty("--offset", dropdown.scrollHeight + 'px');
		
				dropdown.addEventListener("click", function(e) {
					this.classList.toggle("open");
					if (e.target.nodeName === "A") { 
						e.preventDefault();
						selected.textContent = e.target.textContent;
						this.classList.remove("open");
						window.open(e.target.href, "_blank");
					} else {
						selected.textContent = selectedText;
					}
				});
			}
		}); 
	}

	$(".get-here-slides").slick({
		accessibility: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		fade: true,
		arrows: false,
		appendDots: '.get-here-rotator__dots',
		customPaging: function (slider, i) {
			var title = $(slider.$slides[i]).data('title');
			return title;
		}
	});

	$(".inclusions__items").slick({
		accessibility: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		fade: true,
		arrows: false,
		appendDots: '.inclusions__dots',
		customPaging: function (slider, i) {
			var title = $(slider.$slides[i]).data('title');
			return title;
		}
	});
	$(".single-quads-tabs__items").slick({
		accessibility: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		fade: true,
		arrows: false,
		appendDots: '.single-quad-tabs__dots',
		customPaging: function (slider, i) {
			var title = $(slider.$slides[i]).data('title');
			return title;
		}
	});



	$(".galleryBlock-first-slides").not('.slick-initialized').slick({
		accessibility: true,
		autoplay: false,
		arrows: true,
		dots: true,
		autoplaySpeed: 8000,
		fade: false,
		draggable: false,
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		asNavFor: ".galleryBlock-last-slides",
		appendDots: ".informationBlock"
	});

	$(".galleryBlock-last-slides").not('.slick-initialized').slick({
		accessibility: true,
		autoplay: false,
		arrows: true,
		dots: false,
		autoplaySpeed: 8000,
		fade: false,
		draggable: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: ".galleryBlock-first-slides"
	});

	$(".awards-slides").slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 3000,
		speed: 500,
		fade: false,
		accessibility: false,
		slidesToShow: 3
	});

	$('.trio-slider').slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 5500,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 769,
				settings: { slidesToShow: 2 }
			},
			{
				breakpoint: 480,
				settings: { 
					slidesToShow: 1
				}
			}
		]
	});

	$('.slider-triple-items__rotator').slick({
		dots: false,
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 3,		
		autoplay: true,
		autoplaySpeed: 5500,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 769,
				settings: { slidesToShow: 2 }
			},
			{
				breakpoint: 480,
				settings: { 
					slidesToShow: 1
				}
			}
		]
	});
	// .on('init', function(event, slick) {
	// $(this).append('<div class="trio-progress progress-holder"><div class="slideCount"><span class="current"></span> / <span class="total"></span></div><div class="progess-svg-holder"></div></div>');
	// $('.current').text(slick.currentSlide + 1);
	// $('.total').text(slick.slideCount);
	// })
	// .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	//     $('.current').text(nextSlide + 1);
	// }).on('afterChange', function(event, slick, currentSlide){
	//     $('.trio-progress .progess-svg-holder')
	//         .html(`<svg class="progress-svg" width="60" height="60">
	//         <g transform="translate(29,29)">
	//         <circle class="circle-go" r="28" cx="0" cy="0"></circle>
	//         </g> 
	//     </svg>`);
	// }).trigger('afterChange');

	/*Trio Slider content*/

	// function onSuccess2() { 


	// 	console.log("success");

	// 	$('.top-content__email-section--headline').hide();
	// }


	$(document).ready(function () {
		//all booking below

		$('#email-signup-2').submit(function (event) {
			$('.top-content__email-section--headline').hide();
		});

		// $('select:not(.flatpickr-monthDropdown-months)').select2();

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		$.datepicker.regional['es'] = {
			monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			dayNames: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
			dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
			dayNamesMin: ['Do', 'Lu', 'Ma', 'Mc', 'Ju', 'Vi', 'Sa']
		}
		if ($('body').hasClass('lang-es')) {
			$.datepicker.setDefaults($.datepicker.regional['es']);
			$.datepicker.setDefaults({
				dateFormat: 'dd/mm/yy'
			});
		}
		
		$(".arrive").datepicker({
			numberOfMonths: 1,
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 4);
				console.log(newDate);
				$(".depart").datepicker("setDate", newDate);
				$(".depart").datepicker("option", "minDate", getDate);
				setTimeout(function () {
					//$('#book-trigger').trigger('click');	

				}, 300);
			}
		});

		$(".depart").datepicker({
			numberOfMonths: 1,
			onSelect: function (selectedDate) {
				//$( "#arrive" ).datepicker( "option", "maxDate", selectedDate );
				setTimeout(function () {
					//$('#book-trigger').trigger('click');					
				}, 300);
			}
		});

		if(document.querySelector('.js-arrive-allende')){
			$(".arrive").datepicker("option", "minDate", new Date(2024,11,15));
			$(".depart").datepicker("setDate", new Date(2024,11,19));
			$(".depart").datepicker("option", "minDate", new Date(2024,11,19));
		}
	
		$('#property').change(function () {
			var selectVal = $('#property').val();
			if (selectVal === '') {
				$('#mySubmit').prop("disabled", true).addClass('disabled');
			}
			else {
				$('#mySubmit').prop("disabled", false).removeClass('disabled');
			}
			if(selectVal == '10941'){
				$(".arrive").datepicker("option", "minDate", new Date(2024,11,15));
				$(".depart").datepicker("setDate", new Date(2024,11,19));
				$(".depart").datepicker("option", "minDate", new Date(2024,11,19));
			}else{

				let dateActually = new Date();
				let y1 = dateActually.getFullYear();
				let m1 = dateActually.getMonth();
				let d1 = dateActually.getDate();


				let newDate2 = new Date(dateActually.getTime());
				newDate2.setDate(newDate2.getDate() + 4);

				let y2 = newDate2.getFullYear();
				let m2 = newDate2.getMonth();
				let d2 = newDate2.getDate();

				$(".arrive").datepicker("option", "minDate",  new Date(y1,m1,d1));
				//$(".arrive").datepicker("setDate", new Date(y1,m1,d1));
				$(".depart").datepicker("option", "minDate", new Date(y1,m1,d1));
				//$(".depart").datepicker("setDate", new Date(y2,m2,d2));
			}
		});

		$('#ui-datepicker-div').removeClass('ui-helper-hidden-accessible');

		// $('#booking-form').submit(function( event ) {
		// 	event.preventDefault();

		// 	var valid =  validateBooking();
		// 	if (!valid) return false;

		// 	$('#booking-form').submit();
		// });

		$(window).scroll(function () {
			if ($('.mexico-destination-wedding').length > 0) {
				var scrollTop = ($('.top-content').height() + $('.top-content__email-section').height() - 20);
			} else {
				var scrollTop = ($('.top-content').height() + $('.top-content__email-section').height() + 30);
			}

			var headerTop = ($('.header').height());

			var blogFilter = ($('.top-content').height() + $('.intro-copy').height());

			if ($(window).scrollTop() >= scrollTop) {
				$('.sub-nav-section').css({
					position: 'fixed',
					top: headerTop
				});
			}
			if ($(window).scrollTop() < scrollTop) {
				$('.sub-nav-section').removeAttr('style');
			}

			if ($(window).scrollTop() >= headerTop) {
				$('.sub-nav-section').css({
					position: 'fixed',
					top: headerTop
				});
			}

			if ($(window).scrollTop() < headerTop) {
				$('.sub-nav-section').removeAttr('style');
			}

			if ($(window).scrollTop() >= blogFilter) {
				$('.filter-blog').css({
					position: 'fixed',
					top: headerTop
				});
			}
			if ($(window).scrollTop() < blogFilter) {
				$('.filter-blog').removeAttr('style');
			}
		});

		// $(window).load(function () {
		// 	let alertHeight = -$(".topalert").outerHeight()+'px';	
		// 	$(window).scroll(function () {
		// 		var top = $(document).scrollTop();
		// 		if (top > 0) {
		// 			$(".homepage .booking-widget").css('margin-top',alertHeight);
		// 			//$(".homepage .booking-widget").css('margin-top',alertHeight);
		// 		} else {
		// 			$(".homepage .booking-widget").css('margin-top','0px');
		// 		}
		// 	});
		// });
	});

	window.onload = function () {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

}());

function scrollW() {
	if (document.getElementsByTagName("body")[0].classList.contains("san-miguel")) {
		//check scroll down or up for header styles
		let st = window.pageYOffset || document.documentElement.scrollTop;
		let header = document.getElementById('header');
		let headerLogo = document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0];
		var logoUrl = '/assets/images/san-miguel-allende/svg/logo.svg';
		if (st > 80) {
			if (st > lastScrollTop) {
				// downscroll code
				if (!header.classList.contains('down')) {
					header.classList.add('down');
					header.classList.remove('up');
					var logoUrl = '/assets/images/san-miguel-allende/svg/logo_scroll.svg';
					headerLogo.setAttribute('src', logoUrl)
				}
			} else if(st === 0){
				// upscroll code
				if (!header.classList.contains('up')) {
					header.classList.add('up');
					header.classList.remove('down');
					var logoUrl = '/assets/images/san-miguel-allende/svg/logo.svg';
					headerLogo.setAttribute('src', logoUrl)
				}
			}
		} else {
			if (header.classList.contains('up') || header.classList.contains('down')) {
				header.classList.remove('up');
				header.classList.remove('down');
			}
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	}
}


$('.header__lang-active').click(function (e) {
	e.preventDefault();
	$('.header__lang-select').toggleClass('open');
});


